/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-23 23:05:24
 * @LastEditTime: 2022-01-24 22:15:07
 * @LastEditors: zhao - 🍉
 * @Description: 管家
 * @FilePath: /zhzj-admin/src/services/housekeep.js
 */
import request from "../utils/request";
/**
* 管家-管家列表
*
* @export
* @param {{ page: number, pagesize?: number, keyword?: string }} data
*/
export function fetchHouseKeepList(data, option = {}) {
    return request({ url: '/platform/housekeeper/find_page', method: 'post', data, ...option })
}

/**
* 管家-获取管家详情
*
* @export
* @param {{id: number}} data
*/
export function fetchHouseKeepGet(data, option = {}) {
    return request({ url: '/platform/housekeeper/getHousekeeperInfo', method: 'post', data, ...option })
}

/**
* 管家 - 发送签约短信
*
* @export
* @param {*} data
*/
export function fetchHouseKeepSendSignSms(data, option = {}) {
    return request({ url: '/platform/housekeeper/sendSignSms', method: 'post', data, ...option })
}



// WEBPACK FOOTER //
// ./src/services/housekeep.js